import { SettingsLangFactory } from "../../core/lang";
import * as m from "../../core/model/model";

import BokioPlan = m.Entities.BokioPlan;

export const getPlanDescription = (plan: BokioPlan): string => {
	const settingsLang = SettingsLangFactory();

	switch (plan) {
		case BokioPlan.FreeShared: // This shouldn't happen bug we need to keep it for backwards compatibility
		case BokioPlan.Free:
		case BokioPlan.Beta:
			return settingsLang.Plans_BuyModal_Free_Description;
		case BokioPlan.Premium:
			return settingsLang.Plans_BuyModal_Premium_Description;
		case BokioPlan.Pro:
			return settingsLang.Plans_BuyModal_Pro_Description;
		case BokioPlan.Trial_2025:
			return settingsLang.Plans_BuyModal_Trial_2025_Description;
		case BokioPlan.Basic_2025:
			return settingsLang.Plans_BuyModal_Basic_2025_Description;
		case BokioPlan.Premium_2025:
			return settingsLang.Plans_BuyModal_Premium_2025_Description;
		case BokioPlan.Business_2025:
			return settingsLang.Plans_BuyModal_Business_2025_Description;
		case BokioPlan.Plus_2025:
			return settingsLang.Plans_BuyModal_Plus_2025_Description;
		case BokioPlan.Business:
		case BokioPlan.Balance:
		case BokioPlan.Invalid:
			return "";
	}
};
